// Verkleinert ein aufgenommenes Foto im Browser, bevor es hochgeladen wird.
// Handy-Fotos sind schnell 3–8 MB groß und laufen damit in Limits von
// Nginx (client_max_body_size) bzw. Multer — nach der Komprimierung liegen
// sie typischerweise bei 150–400 KB.
const MAX_EDGE = 1280;
const QUALITY  = 0.8;

const loadImage = (file) =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload  = () => { URL.revokeObjectURL(url); resolve(img); };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('Bild konnte nicht gelesen werden')); };
    img.src = url;
  });

export default async function compressImage(file) {
  if (!file || !file.type?.startsWith('image/')) return file;

  try {
    const img = await loadImage(file);
    const scale = Math.min(1, MAX_EDGE / Math.max(img.naturalWidth, img.naturalHeight));
    const width  = Math.max(1, Math.round(img.naturalWidth  * scale));
    const height = Math.max(1, Math.round(img.naturalHeight * scale));

    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    canvas.getContext('2d').drawImage(img, 0, 0, width, height);

    const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', QUALITY));
    if (!blob) return file;
    // Falls das Original schon kleiner ist, bleibt es beim Original.
    if (blob.size >= file.size && scale === 1) return file;

    return new File([blob], 'dish.jpg', { type: 'image/jpeg', lastModified: Date.now() });
  } catch (e) {
    console.error('Foto-Komprimierung fehlgeschlagen:', e);
    return file;
  }
}
